module.exports = __webpack_public_path__ + "img/jiance4.014c3562.png";